import React from "react";

const SaleProductInfo = ({ campervan }) => {
  return (
    <div className="sale-product-info">
      <div className="sale-product-header">
        <div className="sale-status-badge">
          <span
            className={`status-indicator ${campervan.status.toLowerCase()}`}
          >
            {campervan.status}
          </span>
        </div>

        {/* Images moved here - just below status */}
        <div className="sale-product-images-top">
          <div className="main-image-container">
            <img
              src={campervan.mainImage}
              alt={campervan.title}
              className="main-product-image"
            />
          </div>
        </div>

        <h1 className="sale-product-title">{campervan.title}</h1>
        <p className="sale-product-subtitle">{campervan.subtitle}</p>
      </div>

      <div className="sale-product-price">
        <div className="price-section">
          <span className="price-label">Sale Price</span>
          <span className="price-value">{campervan.price}</span>
        </div>
        <div className="price-note">
          <p>
            Price includes full conversion and all equipment. Financing options
            available.
          </p>
        </div>
      </div>

      <div className="sale-product-description">
        <h3>About This Campervan</h3>
        <p>{campervan.description}</p>
      </div>

      <div className="sale-key-features">
        <h3>Key Specifications</h3>
        <div className="key-features-grid">
          <div className="key-feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.854 4.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 11.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                  fill="#009B31"
                />
              </svg>
            </div>
            <span className="feature-text">
              {campervan.specifications.year} Model
            </span>
          </div>
          <div className="key-feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.854 4.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 11.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                  fill="#009B31"
                />
              </svg>
            </div>
            <span className="feature-text">
              {campervan.specifications.mileage}
            </span>
          </div>
          <div className="key-feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.854 4.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 11.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                  fill="#009B31"
                />
              </svg>
            </div>
            <span className="feature-text">
              {campervan.specifications.transmission}
            </span>
          </div>
          <div className="key-feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.854 4.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 11.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                  fill="#009B31"
                />
              </svg>
            </div>
            <span className="feature-text">
              {campervan.specifications.engine}
            </span>
          </div>
        </div>
      </div>

      <div className="sale-warranty-info">
        <div className="warranty-item">
          <h4>Warranty</h4>
          <p>2-year comprehensive warranty on conversion</p>
        </div>
        <div className="warranty-item">
          <h4>Support</h4>
          <p>Lifetime technical support and maintenance</p>
        </div>
        <div className="warranty-item">
          <h4>Documentation</h4>
          <p>Full service history and conversion documentation</p>
        </div>
      </div>
    </div>
  );
};

export default SaleProductInfo;
